/* eslint-disable eqeqeq */
import React, { useState, useEffect, useRef } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Col, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import "./index.scss";
import { getBoundsColour, removeUnderscore, formatValue } from "./../../../../../utils/common"
import { tagPanelAction } from "../../../../../context/actions/tagPanelAction";
import { useDispatch, useSelector } from "react-redux";
import NoRecord2 from "../../../../../components/common/NoRecord2";
import { rightsidebar, set_is_right_clicked } from "../../../../../context/actions/document"; // updateDocumentType
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import Autocomplete from "react-autocomplete";
import { AsyncPaginate } from "react-select-async-paginate";
import { tagSearchAction } from "../../../../../context/actions/tagSearch";
import moment from 'moment';
const DocumentTab = ({ changeInputValue, disabledInputTagsText, checkboxId, editInputBoxId, editInputTagsId, saveversion, disabledSubmitButton, checkCheckbox, checkText, isTextInputEmpty, _acceptXmlText, xmlTags, _changeTab, _editXmlTags, _focus, outSide, _editTagVal, _activeEditTabs, _fieldPriority, loader, noRecordFound, _noRecordFound, _changesXmlTags, _changesXmlText, disabledButtonFlag, acceptedItms, _OnCTextChange, _OnCTagsChange,unableToValidate }) => {


	const fileVersions = useSelector((state) => state.document.fileVersions || []);
	const data = useSelector((state) => state && state.document.fileData);
	const latestVersion = useSelector((state) => state.document.latestVersion);
	const selectedVersion = useSelector((state) => state.document.selectedVersion);
	let fileSetting = useSelector((state) => state?.fileSetting?.data); // get previously filter value
	const selectedPage = useSelector((state) => state.document.page);
	const canvaRender = useSelector((state) => state.general.isCanvaRender);
	let isRightClicked = useSelector((state) => state.document.isRightClicked);
	const is_multi_loan = useSelector((state) => state.document?.fileData?.is_multi_loan);
	const fileData = useSelector((state) => state.document.fileData);
	// let cRedRange = fileSetting.find((item) => {
	// 	if (item.title === 'C Red') {
	// 		return item;
	// 	}
	// });
	// let cYellowRange = fileSetting.find((item) => {
	// 	if (item.title === 'C Yellow') {
	// 		return item;
	// 	}
	// });
	let confidence = fileData?.confidence_range?.aggregator_logo_confidence;
	let cRedRange = fileData?.confidence_range?.c_red
	let cYellowRange = fileData?.confidence_range?.c_yellow
	const dispatch = useDispatch();
	const refs = useRef({});

	const itemHandler = (val) => {
		dispatch(tagPanelAction(false));
	}
	const onTagClick = () => {
		dispatch(set_is_right_clicked(true))
	}
	let [tagFocus, setTagFocus] = useState("");
	useEffect(() => {
		console.log('outSide', outSide)

		if (_focus && refs.current[_focus?.id]) {
			document.getElementsByClassName(refs.current[_focus.id].props.className)[0].scrollIntoView({ behavior: "smooth" });
			document.getElementsByClassName(refs.current[_focus.id].props.className)[0].focus()
		}
		if (_focus && refs.current[_focus?.id + "tag"]) {
			// Scroll and focus on the tag element
			document.getElementsByClassName(refs.current[_focus.id + "tag"].props.className)[0].childNodes[3].type = "";
			document.getElementsByClassName(refs.current[_focus.id + "tag"].props.className)[0].parentNode.scrollIntoView({ behavior: "smooth" });
			document.getElementsByClassName(refs.current[_focus.id + "tag"].props.className)[0].childNodes[3].focus();
			document.getElementsByClassName(refs.current[_focus.id + "tag"].props.className)[0].childNodes[3].type = "hidden";
			console.log(document.getElementsByClassName(refs.current[_focus.id + "tag"].props.className)[0].id, "checing is roghtclickecd in useeffect----->>>>")
			setTagFocus(document.getElementsByClassName(refs.current[_focus.id + "tag"].props.className)[0].id);
		}
		// if (isRightClicked == false) {
		// 	setTagFocus(null)
		// }
		if (!outSide) {
			setTagFocus(null)
		}


	}, [_focus, outSide, isRightClicked]);


	const checkCurrentInput = (id1) => {
		if (document.getElementById(id1)) {
			document.getElementById(id1).style.borderColor = "#0000FF";
		}


	}

	const closeRightSideBar = () => {
		dispatch(rightsidebar('D'));
	}


	/**
	 * @start
	 * Tags autocomplete functinonality
	 */
	const [tagValue, setTagValue] = useState(xmlTags)
	const [value, setValue] = useState("default value");
	const [selectedTag, setSelectedTag] = useState(null)
	// let searchedTags = useSelector((state) => state?.tagSearchReducer?.searchedTag);
	const defaultAdditional = {
		page: 1
	};

	// const onChange = (e) => {
	// 	// props.getUserEmail(e)
	// 	setValue(e.tagName);
	// 	_changesXmlTags(e.target.value, inx);
	// }
	async function loadOptions(modifiedSearch, loadedOptions, { page }) {
		let response = await tagSearchAction({ packet_type: data.packet_type?._id, modifiedSearch: modifiedSearch || selectedTag.replace(/(\r\n|\n|\r)/gm, "").trim(), page })
		// let response = await tagSearchAction({ modifiedSearch: modifiedSearch || selectedTag.replace(/(\r\n|\n|\r)/gm, "").trim(), page })
		// let response = await tagSearchAction({ modifiedSearch: modifiedSearch, page });

		return {
			options: response.docs,
			// hasMore: response.hasNextPage,
			hasMore: response?.docs?.length > 0 ? response.hasNextPage : false,
			additional: {
				page: page + 1,
			},

		};
	}


	/**
	 * @end
	 */
	let i = 0;

	// useEffect(() => {
	// 	let asyncElement = document.getElementsByName("Tagfrm")
	// 	if (asyncElement.length > 0) {
	// 		// asyncElement.pare

	// 		for (let i = 0; i < asyncElement.length; i++) {
	// 			asyncElement[i].className = "customInputClass1";
	// 			asyncElement[i].parentNode.className = "customInputClass2";
	// 			// for (let j = 0; j < asyncElement[i].parentNode.childNodes.length; j++) {
	// 			// 	// asyncElement[i].parentNode.childsNodes[j].className = "customInputClass3"
	// 			// }
	// 		}
	// 	}
	// }, [])

	let [redIndex, setRedIndex] = useState(1)
	let [yellowIndex, setYellowIndex] = useState(1)
	let [greenIndex, setGreenIndex] = useState(1)
	const [wait, setWait] = useState(true);
	//	if (xmin <= xmlMetaRe?.annotation.object[i].bndbox.xmin._text && xmlMetaRe?.annotation.object[i].bndbox.xmax._text <= xmax) {

	useEffect(() => {
		handleIndexes()
	}, [xmlTags])

	const handleIndexes = () => {
		setRedIndex(1)
		setYellowIndex(1)
		setGreenIndex(1)
		if (xmlTags) {
			for (let item of xmlTags) {
				for (let obj of item.overlap) {
					let colr = getBoundsColour(obj.confidence, cYellowRange, cRedRange)
					if (colr === "red") {
						yellowIndex += 1
					}
					else if (colr === "yellow") {
						greenIndex = greenIndex + yellowIndex + 1
					}
				}
			}

			setRedIndex(redIndex)
			setYellowIndex(yellowIndex)
			setGreenIndex(greenIndex)
			setWait(false);
		}
	}
	/**
	 * start, this logic is used to remove focus from canva whenever user navigate out from text tabs
	 */
	document.addEventListener('click', () => {
		//_editTagVal(""); 
		itemHandler(); onTagClick()
	}, true);


	document.addEventListener("focusin", () => {
		if (document.activeElement.id === "text-input") {
			return;
		} else {
			//	_editTagVal(""); 
			itemHandler(); onTagClick()
		}

	});

	// document.addEventListener('keyup', function (e) {
	// 	if (e.keyCode == 9 || e.key == "Tab") {
	// 		// console.log("preeeee checking event listner in tab press......>>>>>>>>>>>>", canvaRender)
	// 		dispatch({ type: "CANVARENDER", data: false });



	// 		setTimeout(() => { dispatch({ type: "CANVARENDER", data: true }); console.log("this is canva distortion console------>>>>") }, 1000)
	// 		// console.log("posttttttt checking event listner in tab press......>>>>>>>>>>>>", canvaRender)
	// 	}

	// }, false);

	/**
	 * end
	 */
	const [textFocus, setTextFocus] = useState(false)

	const [savedTagName, setSavedTagName] = useState([]);

	// const documentLogs = useSelector((state) => state?.document?.documentLogs)



	// useEffect(() => {
	// 	console.log('savedTagName', savedTagName)
	// }, [savedTagName]);

	const onTextKeyDown = () => {

	};

	// const handleTag = (tag) => {
	// 	console.log('checking checklist')
	// };

	// const docVariable =()=>{
	// 	console.log(documentLogs, 'documentLogs running check')
	// 	// documentLogs.docs.forEach((item, index) => {
	// 	// 	console.log('checking mapped item of the document logs', item?.logDetail); // or any other value you want to return, but it won't be used
	// 	// });
	// }





	// console.log('xmlTagsxmlTags',xmlTags)

	return (
		<>
			{/* {console.log(xmlTags, "checking xmlTags in document tag--->>")} */}
			<div className="document-tabs d-flex flex-column flex-fill overflow-auto" >

				<div class="btn-col d-flex align-items-center mt-3">

					{/* <Button color='link' className='submit-btn btn-outline-tertiary' onClick={saveversion} disabled={disabledSubmitButton && !acceptedItms}> */}
					<Button color='link' className='submit-btn btn-outline-tertiary' onClick={saveversion} disabled={disabledSubmitButton}>
						Save
					</Button>

					<Button color='link' className='submit-btn cirular-btn p-0 ms-auto' onClick={closeRightSideBar}>
						<FontAwesomeIcon icon={faClose} />
					</Button>
				</div>
				<Nav tabs className="d-flex">
					<NavItem>
						<NavLink
							disabled={disabledButtonFlag}
							className={_activeEditTabs === '1' ? 'active' : ''}
							onClick={() => { _changeTab('1'); }}
						>
							Text
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							disabled={disabledButtonFlag}
							className={_activeEditTabs === '2' ? 'active' : ''}
							onClick={() => { _changeTab('2'); }}
						>
							Tags
						</NavLink>
					</NavItem>
				</Nav>
				<TabContent activeTab={_activeEditTabs} className="overflow-auto">
					<TabPane tabId="2">
						<div className="tag-item-blc d-flex flex-wrap">
							<div id="blockContainer" className="tag-input-block">
								{loader ? (xmlTags ? (
									xmlTags?.map((item, inx) => {
										let classInput = '';

										// console.log('monday testing results apple', item.updatedAt)

										if (item?.updatedAt && !editInputTagsId.includes(inx + ":" + selectedPage)) {
											classInput = 'inputBlock tagInputBlock'
										}
										else {

											classInput = 'tagInputBlock'
										}

										// let intersectdata = xmlTags[inx] && xmlTags[inx].overlap.filter(item => item.id === intesr[0]?.id);
										// if (intersectdata && intersectdata.length == 0) {}
										return (<Col sm="12" key={`${inx}-sdcols`}>
                                             {!unableToValidate || disabledInputTagsText ?  <div className={item?.updatedAt && `inputBlock` }>
											 <Input name="Tagfrm" id={item?.tag + '-' + inx + 'tag'} disabled={true} className={`${_focus?.id + "tag" === item?.id + "tag" ? 'input-tag-thighlight-tag' : ''}`}  value={removeUnderscore(item?.tag)} /> 
												
											 </div>:
											 <div className={`${classInput} ${item?.tag + '-' + inx + 'tag' === tagFocus ? ' active' : ''}`} >
												{/* <div className={item?.updatedAt ? `inputBlock tagInputBlock` : 'tagInputBlock'}> */}
												{/* <Input name="Tagfrm" id={item?.tag + '-' + inx + 'tag'} className={`${_focus?.id + "tag" === item?.id + "tag" ? 'input-tag-thighlight-tag' : ''}`} onChange={(e) => { _changesXmlTags(e.target.value, inx); }} style={{ borderColor: _focus?.id + "tag" === item?.id + "tag" ? '#0000FF' : '#0000FF' }} type="text" ref={el => refs.current[item?.id + "tag"] = el} onClick={() => { _editXmlTags(inx); itemHandler(); checkCurrentInput(_focus?.id + "tag"); }} value={removeUnderscore(item?.tag)} /> */}
												<AsyncPaginate
													name="Tagfrm"
													id={item?.tag + '-' + inx + 'tag'}
													onChange={(e) => { _changesXmlTags(e.tagName, inx, selectedPage, item?.changesViaVersion, item?.tagId, item); _OnCTagsChange(e, item?.tag ? item.tag : '', inx) }}
													onClick={(e) => { _editXmlTags(inx); itemHandler(); checkCurrentInput(_focus?.id + "tag") }}
													placeholder={removeUnderscore(item?.tag)}
													loadOptions={loadOptions}
													getOptionLabel={(e) => e.tagName}
													defaultValue={removeUnderscore(item.tag)}
													menuPlacement="auto"
													onFocus={() => { setTagFocus(item?.tag + '-' + inx + 'tag'); setSelectedTag(removeUnderscore(item?.tag)); _editXmlTags(inx); itemHandler(); checkCurrentInput(_focus?.id + "tag") }}
													additional={{
														page: 1,
													}}
													selectRef={el => refs.current[item?.id + "tag"] = el}
													styles={{
														option: (styles, { data, isDisabled, isFocused, isSelected }) => {
															return {
																...styles, backgroundColor: isFocused ? "#eef0f7" : null, color: "#333333"

															}
														},
														menu: (styles, { data, isDisabled, isFocused, isSelected }) => {
															return {
																...styles, height: "120px", border: "solid 1px blue"

															}
														},
														menuList: (styles, { data, isDisabled, isFocused, isSelected }) => {
															return {
																...styles, height: "100%", maxHeight: "none"

															}
														}
													}}
													key={item?.tag}
													// style={{ borderColor: _focus?.id + "tag" === item?.id + "tag" ? '#0000FF' : '#0000FF' }}
													// className={`${_focus?.id + "tag" === item?.id + "tag" ? 'input-tag-thighlight-tag' : ''}`}
													// className={_focus?.id + "tag" === item?.id + "tag" ? 'async_elem ' : ''}
													// className={"async_elem"}
													// styles={{ borderColor: "green" }}
													// classNames={{
													// 	control: ({ isDisabled, isFocused }) =>
													// 		classNames(
													// 			!isDisabled && isFocused && 'border-purple-800',
													// 			isFocused && 'shadow-[0_0_0_1px] shadow-purple-800',
													// 			isFocused && 'hover:border-purple-800'
													// 		),
													// 	option: ({ isDisabled, isFocused, isSelected }) =>
													// 		classNames(
													// 			isSelected && 'bg-purple-800',
													// 			!isSelected && isFocused && 'bg-purple-300',
													// 			!isDisabled && isSelected && 'active:bg-purple-800',
													// 			!isDisabled && !isSelected && 'active:bg-purple-500'
													// 		),
													// }}
													// className="react-select-container"
													className={`${_focus?.id + "tag" === item?.id + "tag" ? 'input-tag-thighlight-tag' : ''} react-select-container`}
													classNamePrefix="react-select-custom"

												/>

											</div>
											
											}
										
											
										</Col>)

									})) : (<NoRecord2 />)
								) : (null)


								}
							</div>
						</div>
					</TabPane>
					<TabPane tabId="1">
						{/* <div className="tag-item-blc d-flex flex-wrap"> */}
						<div className={`${_fieldPriority === 2 ? "tag-item-blc2 d-flex flex-wrap" : "tag-item-blc d-flex flex-wrap"}`}>
							{/* {console.log(xmlTags, "xmlTagsssss")} */}
							<div id="blockContainer">
								{loader ? (xmlTags && !wait ? (
									xmlTags?.map((item, indx) => (
										// console.log('xmlTags123', item),
										item?.overlap?.map((overlapItm, inx) => {
											// console.log('overlapItm------>', overlapItm, 'xmlTags', item)
											i++
											if (_fieldPriority === 2 && ((cRedRange.start_range <= overlapItm.confidence && overlapItm.confidence <= cRedRange.end_range) || (cYellowRange.start_range <= overlapItm.confidence && overlapItm.confidence <= cYellowRange.end_range))) {
												if (noRecordFound)
													_noRecordFound(false);
												let classInput = '';
												if (overlapItm && overlapItm?.isAccepted == 1 && overlapItm.updatedAt && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) {

													classInput = 'inputBlock inputBlock2'

												} else if (overlapItm && overlapItm?.isAccepted == 1 && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) {

													classInput = 'inputBlock2'
												}
												else if (overlapItm && overlapItm.updatedAt) {

													if (overlapItm && overlapItm.updatedAt && editInputBoxId.includes(overlapItm.id + ":" + selectedPage)) { //not show any tag if we edit a document until its saved
														//console.log('55555');
														classInput = ''
													}
													else {
														//console.log('6666');
														classInput = 'inputBlock'
													}
												}
												// else if (overlapItm && overlapItm.updatedAt) {

												// 	if (overlapItm && overlapItm.updatedAt && changeInputValue.hasOwnProperty(overlapItm.id + ":" + selectedPage)) { //not show any tag if we edit a document until its saved
												// 		console.log('55555');
												// 		classInput = ''
												// 	}
												// 	else {
												// 		console.log('6666');
												// 		classInput = 'inputBlock'
												// 	}
												// }
												return (<div className={`${classInput} ${getBoundsColour(overlapItm.confidence, cYellowRange, cRedRange)}-input d-flex align-items-center`}>

													{(!(overlapItm?.isAccepted) || checkboxId.includes(overlapItm.id + ":" + selectedPage))
														?
														<Input type="checkbox"
															id={inx + "id"}
															checked={!!overlapItm.isAccepted}
															disabled={disabledInputTagsText || !unableToValidate}
															onClick={(e) => { _acceptXmlText(!overlapItm.isAccepted, indx, inx, overlapItm.id + ":" + selectedPage); _OnCTextChange(e.target.value, item?.tag ? item.tag : '', indx + ':' + inx) }} // setting value to opposite of checked because checked doesnt work on onClick

															title="I accept the data selected as it is presented." /> : ""}

													<Input
														className={`${_focus?.id === overlapItm.id ? 'input-tag-thighlight' : ''} ${getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" && !overlapItm?.isAccepted ? "error-box" : (overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? 'success-box' : getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" ? "error-box" : "success-box"} `}
														ref={el => refs.current[overlapItm.id] = el}
														disabled={disabledInputTagsText || !unableToValidate}
														onChange={(e) => { _changesXmlText(e.target.value, indx, inx, overlapItm.id + ":" + selectedPage); _OnCTextChange(e.target.value, item?.tag ? item.tag : '', indx + ':' + inx) }}
														tabIndex={indx} key={`${indx}-ovrl-${inx} `}
														onClick={(val) => { _editTagVal(overlapItm.id); itemHandler(); onTagClick() }}
														//	style={{ borderColor: overlapItm?.text ? (overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? 'green' : getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) : '#FF0000', borderStyle: (overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? "solid" : getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" ? "dashed" : "solid" }} type="text" name="Tag"
														value={removeUnderscore(overlapItm?.text)} title={removeUnderscore(overlapItm?.text)} />

												</div>)


											} else if (_fieldPriority === 1 && !(cRedRange.start_range <= overlapItm.confidence && overlapItm.confidence <= cRedRange.end_range) && !(cYellowRange.start_range <= overlapItm.confidence && overlapItm.confidence <= cYellowRange.end_range)) {
												if (noRecordFound)
													_noRecordFound(false);

												let classInput = '';
												if (overlapItm && overlapItm?.isAccepted == 1 && overlapItm.updatedAt && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) {
													classInput = 'inputBlock inputBlock2'

												} else if (overlapItm && overlapItm?.isAccepted == 1 && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) {
													//classInput = 'inputBlock2'

												} else if (overlapItm && overlapItm.updatedAt) {
													classInput = 'inputBlock'

												}


												return (<div className={`${classInput} ${overlapItm?.updatedAt && checkText == 0 ? 'inputBlock ' : ''} ${getBoundsColour(overlapItm.confidence, cYellowRange, cRedRange)}-input`}> 
												<Input
													className={`${_focus?.id === overlapItm.id ? 'input-tag-' : ''}`}
													ref={el => refs.current[overlapItm.id] = el}
													onChange={(e) => { _changesXmlText(e.target.value, indx, inx, overlapItm.id + ":" + selectedPage); }} 
													key={`${indx}-ovrl-${inx} `} 
													onClick={(val) => { _editTagVal(overlapItm.id); itemHandler(); }} 
													disabled={disabledInputTagsText || !unableToValidate}
													style={{ borderColor: _focus?.id === overlapItm.id ? '#FF0000' : '#0000FF' }} 
													type="text" name="Tag" value={removeUnderscore(overlapItm?.text)} 
													title={removeUnderscore(overlapItm?.text)} /></div>)
											} else if (!_fieldPriority) {
												if (noRecordFound)
													_noRecordFound(false);

												let classInput = '';
												if (overlapItm && overlapItm?.isAccepted == 1 && overlapItm.updatedAt && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) {

													classInput = 'inputBlock inputBlock2'

												} else if (overlapItm && overlapItm?.isAccepted == 1 && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) {

													classInput = 'inputBlock2'
												}

												// else if (overlapItm && overlapItm.updatedAt) {

												// 	if (overlapItm && overlapItm.updatedAt && !editInputBoxId.includes(overlapItm.id + ":" + selectedPage) && overlapItm?.changesViaVersion) { //not show any tag if we edit a document until its saved
												// 		console.log('7777');
												// 		classInput = 'inputBlock'
												// 	}
												// 	else {
												// 		console.log('8888');
												// 		classInput = ''
												// 	}
												// }
												//disha checking for edited tag
												else if (overlapItm && overlapItm.updatedAt) {
													// console.log('overlapItm.id', overlapItm.text,editInputBoxId,  ',' + overlapItm.id + ":" + selectedPage, "  version " + overlapItm?.changesViaVersion);
													if (overlapItm && overlapItm.updatedAt && !editInputBoxId.includes(overlapItm.id + ":" + selectedPage) && overlapItm?.changesViaVersion) { //not show any tag if we edit a document until its saved
														//console.log('7777');
														classInput = 'inputBlock'
													}
													else {
														//console.log('8888');
														classInput = ''
													}
												}


												//*********start, tab index updating for index resequencing************
												let currentColr = getBoundsColour(overlapItm.confidence, cYellowRange, cRedRange);
												let gI = greenIndex;
												let rI = redIndex;
												let yI = yellowIndex;
												if (currentColr === "green") {
													greenIndex++
												}
												else if (currentColr === "yellow") {
													yellowIndex++;
												}
												else {
													redIndex++;
												}
 
												console.log("overlapItm.intersectedArea",overlapItm)
												console.log("overlapItm.intersectedArea",cRedRange)
												console.log("overlapItm.intersectedArea",cYellowRange)

												//****end*****

												return (<div className={`${classInput} ${getBoundsColour(overlapItm.confidence, cYellowRange, cRedRange)}-input d-flex align-items-center   `}>


													{/*<p> {'x ' +  overlapItm?.x + ' y ' +  overlapItm?.y + ' w ' +  overlapItm?.w + ' xmax' + overlapItm?.xmax  + ' xmin' + overlapItm?.xmin + ' ymax' + overlapItm?.ymax} </p> */}

													{(!(overlapItm?.isAccepted) || checkboxId.includes(overlapItm.id + ":" + selectedPage)) && ((cRedRange?.start_range <= overlapItm.confidence && overlapItm.confidence <= cRedRange?.end_range) || (cYellowRange?.start_range <= overlapItm.confidence && overlapItm.confidence <= cYellowRange?.end_range))

														?
														<Input type="checkbox"
															id={inx + "id"}
															checked={!!overlapItm.isAccepted}
															disabled={disabledInputTagsText || !unableToValidate}
															tabIndex={currentColr === "green" ? greenIndex : currentColr === "yellow" ? yellowIndex : redIndex}
															onClick={(e) => { _acceptXmlText(!overlapItm.isAccepted, indx, inx, overlapItm.id + ":" + selectedPage); _OnCTextChange(e.target.value, item?.tag ? item.tag : '', indx + ':' + inx, overlapItm.isAccepted) }} // setting value to opposite of checked because checked doesnt work on onClick
															title="I accept the data selected as it is presented." /> 
															
														: ""}

													<Input
														id={"text-input"}
														className={`${_focus?.id === overlapItm.id ? 'input-tag-thighlight' : ''} ${getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" && !overlapItm?.isAccepted ? "error-box" : (overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? 'success-box' : getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" ? "error-box" : "success-box"} `}
														ref={el => refs.current[overlapItm.id] = el}
														// onChange={(e) => { _changesXmlText(e.target.value, indx, inx, overlapItm.id + ":" + selectedPage); }} tabindex={i} key={`${indx}-ovrl-${inx} `}
														onChange={(e) => { _OnCTextChange(e.target.value, item?.tag ? item.tag : '', indx + ':' + inx); _changesXmlText(e.target.value, indx, inx, overlapItm.id + ":" + selectedPage, overlapItm); }}
														tabIndex={currentColr === "green" ? gI : currentColr === "yellow" ? yI : rI} key={`${indx}-ovrl-${inx} `}
														onClick={(val) => { _editTagVal(overlapItm.id); itemHandler(); onTagClick() }}
														onFocus={(e) => {
															_editTagVal(overlapItm.id); itemHandler(); onTagClick()
														}}
														disabled={disabledInputTagsText || !unableToValidate}

														// style={{ borderColor: overlapItm?.text ? (overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? 'green' : /*getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange)*/ 'blue' : '#FF0000', border: (overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? "solid" : getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" ? "10px solid transparent !important" : "solid", borderWidth: getBoundsColour(overlapItm?.confidence, cYellowRange, cRedRange) == "red" && !(overlapItm?.isAccepted && !checkboxId.includes(overlapItm.id + ":" + selectedPage)) ? "3px" : "1.3px" }}
														type="text" name="Tag"
														value={removeUnderscore(overlapItm?.text)} title={removeUnderscore(overlapItm?.text)} />


												</div>)

											}

										}))
									)

								) : (
									<NoRecord2 />
								)
								) : (null)

								}
								{noRecordFound && loader && xmlTags !== undefined && (
									<NoRecord2 />
								)}
							</div>
						</div>
					</TabPane>
				</TabContent>
			</div>
		</>
	);

}

export default DocumentTab;